import type { IconData } from '@stacksjs/iconify-core'

export const basicUiTime2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 8a8 8 0 0 1-8-8h16a8 8 0 0 1-8 8\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 8a8 8 0 0 0-7.418 5A8 8 0 0 0 0 16h16a8 8 0 0 0-.581-3A8 8 0 0 0 8 8m0 3a5 5 0 0 0-4 2h8a5 5 0 0 0-4-2\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiTime2
